export class AsyncDropdown {
  constructor() {
    this.identifier = '';
    this.code = '';
    this.name = '';
  }

  identifier: string;
  code: string;
  name: string;
  fullName?: string;
}
